import { WatcherActionTypes } from "../Constants/Types";
import WatcherType from "../Interfaces/watcher.interface";

const WatcherReducer = (state: WatcherType['status'] = { 
        messages: [],
        message: undefined,
        automations: [],
        automation: undefined,
        lmessages: false,
        lmessage: false,
        lautomations: false,
        lautomation: false,
        pages: 0,
        total: 0,
        error: ''
    },
    action: WatcherType['action']
    ) => {

    switch (action.type) {

        case WatcherActionTypes.FETCH_MESSAGES:
            return {...state, messages: action.payload, pages: action.pages, total: action.total};

        case WatcherActionTypes.FETCH_MESSAGE:
            return {...state, message: action.payload};

        case WatcherActionTypes.CREATE_MESSAGE:
            return {...state, messages: [action.payload, ...state.messages], total: state.total + 1};

        case WatcherActionTypes.UPDATE_MESSAGE: 
            return {...state, messages: state.messages.map(message => message._id === action.payload._id ? action.payload : message)};
        
        case WatcherActionTypes.STATE_MESSAGE: 
            return {...state, messages: state.messages.map(message => message._id === action.payload.id ? {...message, isActive: action.payload.isActive} : message)};

        case WatcherActionTypes.DELETE_MESSAGE: 
            return {...state, messages: state.messages.filter(message => message._id !== action.payload), total: state.total - 1};

        case WatcherActionTypes.LOADING_MESSAGES:
            return {...state, lmessages: action.payload !== false ? true : false};

        case WatcherActionTypes.LOADING_MESSAGE:
            return {...state, lmessage: action.payload !== false ? true : false};

        case WatcherActionTypes.ERROR_MESSAGES:
            return {...state, error: action.payload};

        case WatcherActionTypes.ERROR_MESSAGE:
            return {...state, error: action.payload};

        case WatcherActionTypes.RESET_MESSAGES_ERROR:
            return {...state, error: ''};

        case WatcherActionTypes.FETCH_AUTOMATIONS:
            return {...state, automations: action.payload, pages: action.pages, total: action.total};

        case WatcherActionTypes.FETCH_AUTOMATION:
            return {...state, automation: action.payload};

        case WatcherActionTypes.CREATE_AUTOMATION:
            return {...state, automations: [action.payload, ...state.automations], total: state.total + 1};

        case WatcherActionTypes.UPDATE_AUTOMATION: 
            return {...state, automations: state.automations.map(automation => automation._id === action.payload._id ? action.payload : automation)};
        
        case WatcherActionTypes.STATE_AUTOMATION: 
            return {...state, automations: state.automations.map(automation => automation._id === action.payload.id ? {...automation, isActive: action.payload.isActive} : automation)};

        case WatcherActionTypes.DELETE_AUTOMATION: 
            return {...state, automations: state.automations.filter(automation => automation._id !== action.payload), total: state.total - 1};

        case WatcherActionTypes.LOADING_AUTOMATIONS:
            return {...state, lautomations: action.payload !== false ? true : false};

        case WatcherActionTypes.LOADING_AUTOMATION:
            return {...state, lautomation: action.payload !== false ? true : false};

        default: 
            return state
    }
}

export default WatcherReducer;
